import React from 'react';
import classnames from 'classnames';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';

const Checker = ({ name, value, onChange }) => {
	// Handle input's value change
	const handle = () => {
		onChange({ name, value: !value });
	};

	// Element's classnames
	const elementClassName = classnames(
		'w-5 h-5 rounded-md border border-neutral-200 dark:border-neutral-700 flex items-center justify-center cursor-pointer transition-colors',
		value && 'border-amber-500 dark:border-amber-500'
	);

	return (
		<div className={elementClassName} onClick={handle}>
			<Show if={value}>
				<Icon icon="done" className="text-xs text-amber-500" />
			</Show>
		</div>
	);
};

export default Checker;